export default __webpack_public_path__ + "static/media/tv.6d656ff2.svg";